if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
        formData.delete('id');
        formData.delete('quantity');
      }

      config.body = formData;
      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = '/checkout';
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => { console.error(e); })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}

(function() {
  'use strict';
  if (window.BillionProductFormFix) return;
  window.BillionProductFormFix = true;

  function initAll() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(initProductSection);
  }

  function initProductSection(root) {
    if (!root || root.dataset.billionProductFormFixed === 'true') return;
    root.dataset.billionProductFormFixed = 'true';

    var sectionId = root.id.replace('MainProduct-', '');
    var picker = root.querySelector('variant-radios, variant-selects');
    var variants = readVariants(picker);
    var stickyBar = root.querySelector('.billion-sticky-atc') || document.querySelector('.billion-sticky-atc[data-section-id="' + sectionId + '"]');
    var mainButton = root.querySelector('.billion-atc-submit, .product-form__submit');
    var mainAtcRow = root.querySelector('.billion-atc-row') || mainButton;

    if (!picker) {
      root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input) {
        if (input.value) {
          input.disabled = false;
          input.removeAttribute('disabled');
        }
      });
      setupQuantitySync(root);
      setupSticky(stickyBar, mainAtcRow);
      return;
    }

    function sync() {
      var variant = findVariant(root, picker, variants);
      syncVariantInputs(root, variant);
      syncButtons(root, variant);
      syncGallery(root, sectionId, variant);
      dispatchVariantChanged(sectionId, variant);
      updateSticky(stickyBar, mainAtcRow);
    }

    if (picker) {
      picker.addEventListener('change', function() { window.setTimeout(sync, 20); });
      picker.addEventListener('click', function(event) {
        if (event.target.closest('label, input, select')) window.setTimeout(sync, 35);
      });
    }

    root.addEventListener('change', function(event) {
      if (event.target.matches('input[type="radio"], select')) window.setTimeout(sync, 20);
    });

    setupQuantitySync(root);
    setupSticky(stickyBar, mainAtcRow);
    window.setTimeout(sync, 60);
    window.setTimeout(sync, 300);
  }

  function readVariants(picker) {
    if (!picker) return [];
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent || '[]'); }
    catch (error) { return []; }
  }

  function selectedOptions(picker) {
    if (!picker) return [];
    var values = [];
    picker.querySelectorAll('fieldset').forEach(function(fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var select = fieldset.querySelector('select');
      if (checked) values.push(checked.value);
      else if (select) values.push(select.value);
    });
    if (values.length) return values;
    var checkedInputs = picker.querySelectorAll('input[type="radio"]:checked');
    if (checkedInputs.length) return Array.prototype.map.call(checkedInputs, function(input) { return input.value; });
    return Array.prototype.map.call(picker.querySelectorAll('select'), function(select) { return select.value; });
  }

  function findVariant(root, picker, variants) {
    var options = selectedOptions(picker);
    var variant = null;
    if (options.length) {
      variant = variants.find(function(item) {
        return item.options && item.options.every(function(option, index) {
          return String(option) === String(options[index]);
        });
      });
    }
    if (!variant) {
      var currentInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
      var currentId = currentInput && currentInput.value;
      variant = variants.find(function(item) { return String(item.id) === String(currentId); });
    }
    return variant || null;
  }

  function syncVariantInputs(root, variant) {
    root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input) {
      if (!variant) {
        input.value = '';
        input.disabled = true;
        input.setAttribute('disabled', 'disabled');
        return;
      }
      input.value = variant.id;
      input.dataset.selectedId = variant.id;
      input.disabled = false;
      input.removeAttribute('disabled');
    });
  }

  function syncButtons(root, variant) {
    var available = !!(variant && variant.available);
    var strings = window.variantStrings || {};
    var label = available ? strings.addToCart : variant ? strings.soldOut : strings.unavailable;
    label = label || (available ? 'Adicionar ao carrinho' : 'Indisponivel');

    root.querySelectorAll('product-form .product-form__submit, product-form .atc-button').forEach(function(button) {
      var span = button.querySelector('span');
      button.disabled = !available;
      button.toggleAttribute('disabled', !available);
      if (available) button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', 'true');
      if (span) span.textContent = label;
    });
  }

  function variantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    return null;
  }

  function syncGallery(root, sectionId, variant) {
    var mediaId = variantMediaId(variant);
    if (!mediaId) return;
    var themeMediaId = sectionId + '-' + mediaId;
    var gallery = root.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(themeMediaId, false);

    var list = root.querySelector('[data-billion-gallery-track]');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('[data-media-id]'));
    var target = slides.find(function(slide) { return slide.dataset.mediaId === themeMediaId; });
    if (!target) return;
    var index = slides.indexOf(target);
    var left = target.offsetLeft - list.offsetLeft;
    list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    slides.forEach(function(slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === index);
      slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
    });
    root.querySelectorAll('.billion-gallery-dot').forEach(function(dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
    var current = root.querySelector('.slider-counter--current');
    if (current) current.textContent = String(index + 1);
    var prev = root.querySelector('[data-billion-gallery-prev]');
    var next = root.querySelector('[data-billion-gallery-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= slides.length - 1;
  }

  function dispatchVariantChanged(sectionId, variant) {
    try {
      document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { sectionId: sectionId, variant: variant } }));
    } catch (error) {
      var event = document.createEvent('Event');
      event.initEvent('variant:changed', true, true);
      event.variant = variant;
      document.dispatchEvent(event);
    }
  }

  function setupQuantitySync(root) {
    if (root.dataset.billionQuantityFixed === 'true') return;
    root.dataset.billionQuantityFixed = 'true';
    function normalize(value) {
      var quantity = parseInt(value, 10);
      return isNaN(quantity) || quantity < 1 ? 1 : quantity;
    }
    function setQuantity(value) {
      var quantity = normalize(value);
      root.querySelectorAll('.billion-atc-qty-input').forEach(function(input) { input.value = quantity; });
    }
    root.addEventListener('click', function(event) {
      var button = event.target.closest('.billion-atc-qty-btn');
      if (!button) return;
      var group = button.closest('.billion-atc-quantity');
      var input = group && group.querySelector('.billion-atc-qty-input');
      if (!input) return;
      var quantity = normalize(input.value);
      if (button.dataset.quantityAction === 'minus') quantity = Math.max(1, quantity - 1);
      if (button.dataset.quantityAction === 'plus') quantity += 1;
      setQuantity(quantity);
    });
    root.addEventListener('change', function(event) {
      if (event.target.matches('.billion-atc-qty-input')) setQuantity(event.target.value);
    });
  }

  function setupSticky(stickyBar, target) {
    if (!stickyBar || !target || stickyBar.dataset.billionStickyFixed === 'true') return;
    stickyBar.dataset.billionStickyFixed = 'true';
    stickyBar.classList.remove('is-visible');
    var update = function() { updateSticky(stickyBar, target); };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        var aboveViewport = entry && entry.boundingClientRect && entry.boundingClientRect.top < 0;
        var shouldShow = !!(entry && !entry.isIntersecting && aboveViewport && window.scrollY > 80 && !isCartOpen());
        stickyBar.classList.toggle('is-visible', shouldShow);
      }, { threshold: 0.01 });
      observer.observe(target);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('cart:open', update);
    document.addEventListener('cart:close', update);
    window.setTimeout(update, 80);
    window.setTimeout(update, 500);
  }

  function updateSticky(stickyBar, target) {
    if (!stickyBar || !target) return;
    var rect = target.getBoundingClientRect();
    var shouldShow = rect.bottom <= 0 && window.scrollY > 80 && !isCartOpen();
    stickyBar.classList.toggle('is-visible', shouldShow);
  }

  function isCartOpen() {
    return document.body.classList.contains('billion-cart-drawer-open') ||
      document.documentElement.classList.contains('billion-cart-drawer-open') ||
      !!document.querySelector('cart-drawer.active, cart-drawer[open], .drawer.active');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
